import styles from "./ButtonsPanel.module.scss";

export function ButtonsPanel({ children }: { children: JSX.Element | JSX.Element[] }): JSX.Element {
    return <div className={styles.buttonsPanel}>{children}</div>;
}
